/* eslint-disable no-useless-escape */
import { Grid } from "@mui/material";
import MDBox from "components/MDBox";
import { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import { URL_API } from "config";
import BaseLayout from "layouts/pages/account/components/BaseLayout";
import Card from "@mui/material/Card";
import MDTypography from "components/MDTypography";
import MDAvatar from "components/MDAvatar";
import MDButton from "components/MDButton";
import MDInput from "components/MDInput";
import { useAuthContext } from "context/AuthContext";

function Perfil() {
  const [newPassword, setNewPassword] = useState({
    newPassword: "",
    currentPassword: "",
    confirmNewPassword: "",
  });
  const navigate = useNavigate();

  const { user } = useAuthContext();

  let tag = localStorage.getItem("Tag");

  function hasSomething(str) {
    if (str === "") {
      return false;
    }
    return true;
  }
  function hasUpper(str) {
    return hasSomething(str) && /[A-Z]/.test(str);
  }
  function hasLower(str) {
    return hasSomething(str) && /[a-z]/.test(str);
  }
  function hasNumber(str) {
    return hasSomething(str) && /\d/.test(str);
  }
  function hasLength(str) {
    return (
      hasSomething(str) &&
      /^(?=.*?[a-zA-Z])[a-zA-Z0-9!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]{8,}$/.test(
        str
      )
    );
  }
  function hasSpecialCharacter(str) {
    return (
      hasSomething(str) && /[ `!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/.test(str)
    );
  }
  function checkAll(str) {
    return (
      hasLower(str) &&
      hasUpper(str) &&
      hasNumber(str) &&
      hasSpecialCharacter(str) &&
      hasLength(str) &&
      newPassword.newPassword === newPassword.confirmNewPassword &&
      newPassword.currentPassword
    );
  }

  function handleChange(event) {
    const { name, value } = event.target;

    setNewPassword((password) => {
      return {
        ...password,
        [name]: value,
      };
    });
  }

  async function updatePassword() {
    await axios
      .put(URL_API + `/users/change-password/${user.uuid}`, newPassword, {
        headers: {
          Authorization: `Bearer ${tag}`,
        },
      })
      .then(() => {
        toast.success("Senha Atualizada!");
      })
      .catch((error) => {
        if (error?.response?.status === 401) {
          localStorage.removeItem("Tag");
          navigate("/auth/login");
        } else {
          toast.error(error.response.data);
        }
      });
      setNewPassword({
        newPassword: "",
        currentPassword: "",
        confirmNewPassword: "",
      });
  }

  return (
    <>
      <BaseLayout>
        <MDBox mt={4}>
          <Grid container spacing={3}>
            <Grid item xs={12} lg={9}>
              <MDBox mb={3}>
                <Grid container spacing={3}>
                  <Grid item xs={12}>
                    <Card id="profile">
                      <MDBox p={2}>
                        <Grid container spacing={3} alignItems="center">
                          <Grid item>
                            <MDAvatar
                              src={user.name}
                              alt="profile-image"
                              size="xl"
                              shadow="sm"
                            >
                              <MDTypography variant="h5" fontWeight="medium">
                                {user.name?.split("")[0]}
                              </MDTypography>
                            </MDAvatar>
                          </Grid>
                          <Grid item>
                            <MDBox height="100%" mt={0.5} lineHeight={1}>
                              <MDTypography variant="h5" fontWeight="medium">
                                {user.name}
                              </MDTypography>
                              <MDTypography
                                variant="button"
                                color="text"
                                fontWeight="medium"
                              >
                                {user.email}
                              </MDTypography>
                            </MDBox>
                          </Grid>
                        </Grid>
                      </MDBox>
                    </Card>
                  </Grid>
                  <Grid item xs={12}>
                    <Card id="change-password">
                      <MDBox p={3}>
                        <MDTypography variant="h5">Alterar Senha</MDTypography>
                      </MDBox>
                      <MDBox component="form" pb={3} px={3}>
                        <Grid container spacing={3}>
                          <Grid item xs={12}>
                            <MDInput
                              fullWidth
                              name="currentPassword"
                              label="Senha Atual"
                              value={newPassword.currentPassword}
                              onChange={handleChange}
                              inputProps={{
                                type: "password",
                                autoComplete: "",
                              }}
                            />
                          </Grid>
                          <Grid item xs={12}>
                            <MDInput
                              fullWidth
                              name="newPassword"
                              label="Nova Senha"
                              value={newPassword.newPassword}
                              onChange={handleChange}
                              inputProps={{
                                type: "password",
                                autoComplete: "",
                              }}
                            />
                          </Grid>
                          <Grid item xs={12}>
                            <MDInput
                              fullWidth
                              name="confirmNewPassword"
                              label="Confirme Nova Senha"
                              value={newPassword.confirmNewPassword}
                              onChange={handleChange}
                              inputProps={{
                                type: "password",
                                autoComplete: "",
                              }}
                            />
                          </Grid>
                        </Grid>
                        <MDBox mt={6} mb={1}>
                          <MDTypography variant="h5">
                            Requerimentos para senha
                          </MDTypography>
                        </MDBox>
                        <MDBox mb={1}>
                          <MDTypography variant="body2" color="text">
                            Siga esse guia para uma senha forte
                          </MDTypography>
                        </MDBox>
                        <MDBox
                          display="flex"
                          justifyContent="space-between"
                          alignItems="flex-end"
                          flexWrap="wrap"
                        >
                          <MDBox
                            component="ul"
                            m={0}
                            pl={3.25}
                            mb={{ xs: 8, sm: 0 }}
                          >
                            <MDBox
                              component="li"
                              color="text"
                              fontSize="1.25rem"
                              lineHeight={1}
                            >
                              <MDTypography
                                variant="button"
                                color={
                                  hasLength(newPassword.newPassword)
                                    ? "success"
                                    : !hasSomething(newPassword.newPassword) ? "text" : "error"
                                }
                                fontWeight="regular"
                                verticalAlign="middle"
                              >
                                Contém um minímo de 8 caracteres
                              </MDTypography>
                            </MDBox>
                            <MDBox
                              component="li"
                              color="text"
                              fontSize="1.25rem"
                              lineHeight={1}
                            >
                              <MDTypography
                                variant="button"
                                color={
                                  hasUpper(newPassword.newPassword)
                                    ? "success"
                                    : !hasSomething(newPassword.newPassword) ? "text" : "error"
                                }
                                fontWeight="regular"
                                verticalAlign="middle"
                              >
                                Contém letras maiúsculas
                              </MDTypography>
                            </MDBox>
                            <MDBox
                              component="li"
                              color="text"
                              fontSize="1.25rem"
                              lineHeight={1}
                            >
                              <MDTypography
                                variant="button"
                                color={
                                  hasLower(newPassword.newPassword)
                                    ? "success"
                                    : !hasSomething(newPassword.newPassword) ? "text" : "error"
                                }
                                fontWeight="regular"
                                verticalAlign="middle"
                              >
                                Contém letras minúsculas
                              </MDTypography>
                            </MDBox>
                            <MDBox
                              component="li"
                              color="text"
                              fontSize="1.25rem"
                              lineHeight={1}
                            >
                              <MDTypography
                                variant="button"
                                color={
                                  hasSpecialCharacter(newPassword.newPassword)
                                    ? "success"
                                    : !hasSomething(newPassword.newPassword) ? "text" : "error"
                                }
                                fontWeight="regular"
                                verticalAlign="middle"
                              >
                                Contém caracteres especiais
                              </MDTypography>
                            </MDBox>
                            <MDBox
                              component="li"
                              color="text"
                              fontSize="1.25rem"
                              lineHeight={1}
                            >
                              <MDTypography
                                variant="button"
                                color={
                                  hasNumber(newPassword.newPassword)
                                    ? "success"
                                    : !hasSomething(newPassword.newPassword) ? "text" : "error"
                                }
                                fontWeight="regular"
                                verticalAlign="middle"
                              >
                                Contém números
                              </MDTypography>
                            </MDBox>
                          </MDBox>
                          <MDBox ml="auto">
                            <MDButton
                              variant="gradient"
                              color="dark"
                              size="small"
                              onClick={updatePassword}
                              disabled={!checkAll(newPassword.newPassword)}
                            >
                              Atualizar Senha
                            </MDButton>
                          </MDBox>
                        </MDBox>
                      </MDBox>
                    </Card>
                  </Grid>
                </Grid>
              </MDBox>
            </Grid>
          </Grid>
        </MDBox>
      </BaseLayout>
      <ToastContainer />
    </>
  );
}

export default Perfil;
